import { render, staticRenderFns } from "./BetslipWinningsWithTax.vue?vue&type=template&id=ce142ca0&"
import script from "./BetslipWinningsWithTax.vue?vue&type=script&lang=js&"
export * from "./BetslipWinningsWithTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports